import { useMemo, useState } from 'react'
import { Toolbox } from '~/plugins/toolbox/shared'
import { UIChatItem, UIChatReaction } from '../../../types'

const getEmojiError = (item: UIChatItem) => {
  const options: UIChatReaction[] = ['🙇', '😞']

  const index = Toolbox.Utility.stringToRandomNumber(
    item.id,
    0,
    options.length - 1,
  )

  return options[index] ?? options[0]
}

type Props = {
  item: UIChatItem
  onReaction: (reaction: UIChatReaction) => void
}

export const useReactions = ({ item, onReaction }: Props) => {
  const [reactionsLocal, setReactionsLocal] = useState<UIChatReaction[]>([])

  const reactions = item?.values?.reactions ?? []
  const reactionsEnsured = [...reactions, ...reactionsLocal]

  const isChecked = item?.values?.isChecked
  const isError = item?.values?.isError

  const reactionsBuilt = useMemo(() => {
    const items = reactionsEnsured

    if (isChecked) {
      items.push('✅')
    }

    if (isError) {
      items.push(getEmojiError(item))
    }

    return items
  }, [reactionsEnsured, isChecked, isError])

  const handleReaction = (reaction: UIChatReaction) => {
    setReactionsLocal(values => [...values, reaction])
    onReaction(reaction)
  }

  return {
    reactions: reactionsBuilt,
    handleReaction,
  }
}
